<template>
	<div class="choice_container">
		<el-tag
			:value="value"
			size="medium"
			:type="check? undefined : 'info'"
			:effect="check? 'light' : 'plain'"
			@click="checkTag(value)"
			class="tag"
		>{{text}}</el-tag>
	</div>
</template>
<script>
export default {
	props: {
		value: {
			type: Boolean,
		},
		text: {
			type: String,
		},
	},
	watch: {
		value: {
			handler: function (val) {
				this.check = val;
			},
		},
	},
	data() {
		return {
			check: false,
		};
	},
	methods: {
		checkTag(value) {

			this.check = !value;
			this.$emit('input', this.check);
		},
	},
	components: {},
};
</script>
<style lang="scss" scoped>
.choice_container {
	display: inline-block;
	.tag {
		cursor: pointer;
		margin-right: 10px;
		margin-top: 15px;
	}
}
</style>
